export default __webpack_public_path__ + "static/clouds-43d642fdb0083c9fc8076073df232f85.jpg";